var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.initialized
    ? _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _vm._v("\n        " + _vm._s(_vm.label || "Commands") + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body card-commands" }, [
          _c(
            "div",
            [
              _vm._l(_vm.commands, function(command) {
                return [
                  _c(
                    "command-component",
                    _vm._b(
                      {
                        key: command.name,
                        on: {
                          input: function(data) {
                            return _vm.updateCommand(command.name, data)
                          },
                          show: function() {
                            return _vm.showCommand(command.name)
                          },
                          hide: function() {
                            return _vm.hideCommand(command.name)
                          },
                          run: function() {
                            return _vm.runCommand(command)
                          },
                          stop: function() {
                            return _vm.stopCommand(command)
                          },
                          track: function() {
                            return _vm.trackCommand(command)
                          }
                        }
                      },
                      "command-component",
                      command,
                      false
                    )
                  )
                ]
              })
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61a1428e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61a1428e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/dashboard-elements/CommandPanelComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-61a1428e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/dashboard-elements/CommandPanelComponent.vue
// module chunks = 0